export const redirectThis = ({ navigate, message }) => {
  let user = localStorage.getItem("user");
  let userToken = localStorage.getItem("user");
  if (!user || !userToken) {
    return navigate(`/login?message=${message}`);
  }
};
